import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { DeactivateRequest, DeactivateSuccess, DeactivateFailure } from '../reducers/deactivate';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/deregister`;

function* deactivateAxios() {

  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const response = yield call(() => {

  return axios({
    method: 'post',
    url: API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'same-origin',
    data: {
      user_id: userId
    },
  });
});

  return response;
}

function* workerDeactivateSaga() {
  try {
    const response = yield call(deactivateAxios);
    const responseFromDeactivate= response.data;
    yield put(DeactivateSuccess(responseFromDeactivate));
    if (response.status === 500) {
      yield put(DeactivateFailure(responseFromDeactivate));
    }
  } catch (error) {
     yield put(DeactivateFailure(error));
  }
}

export function* watcherDeactivateSaga() {
  yield takeLatest(DeactivateRequest().type, workerDeactivateSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/deactivate.js